import React, { Component } from 'react';
import axios from 'axios';
import { get } from 'lodash-es';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UncontrolledTooltip } from 'reactstrap';

import AuctionGroupHeader from './AuctionGroupHeader';
import PendingApprovalLink from './PendingApprovalLink';
import { cfPath } from '../../utilities/UrlPaths';

/**
 * (dyouberg) This file represents the Container for each sale.  Certain logic to determine icons,
 * sale name, pending approvals, and adding session are all in this file.
 */
class AuctionGroupContainer extends Component {
  handleAddSession = async () => {
    const { group: { groupID, groupName, live } } = this.props;
    const groupInfoResponse = await axios(`/cps/app/group/${groupID}/info`);
    const canAddCatalogs = get(groupInfoResponse, 'data.data.groupInfo.canAddCatalogs', false);
    if (canAddCatalogs) {
      this.props.history.push(`/session/${!live ? 'timed' : 'live'}/${groupID}/0/1`);
    } else {
      // Display error to user in the parent auction container
      this.props.handleCatalogsExceeded(groupName);
    }
  };

  render() {
    const { group, house, type, user, disableAddSaleAndSessionButton, disableAddSessionButton } = this.props;
    const {
      catalogs,
      groupID,
      groupName,
      groupSettingsID,
      houseFeeStepEnabled,
      live,
      pendingApprovalsCount
    } = group;

    const { isHouseFeeStepActive } = house;
    const { accessCustomer } = user;

    const disableAddSession = isHouseFeeStepActive !== houseFeeStepEnabled 
    || disableAddSaleAndSessionButton || disableAddSessionButton;

  const cantAddSessionTooltipText = disableAddSaleAndSessionButton ? 'Complete payment processing sign up to upload new sales.' : 'Your house has a different fee structure than this group, so in order to prevent invoice errors you can\'t add new sessions to this group. Please create a new group.';

    // Show 'New' badge for unsold live to timed
    const showUnsoldBadge = catalogs.some(
      catalog => catalog.unsoldLivetoTimedCatalog && catalog.lotCount === 0
    );

    return (
      <div className="auction-container px-3">
        <AuctionGroupHeader
          groupName={groupName}
          live={live}
          showUnsoldBadge={showUnsoldBadge}
          groupId={groupID}
        />

        {type === 'current' && (
          <span className="float-right">
            <a
              className="link-secondary px-2"
              href={`${cfPath()}/al/settings/groupSettings.cfm?groupID=${groupID}&groupSettingsID=${groupSettingsID}&isDefault=false`}
            >
              Edit Terms
            </a>
            |
            <PendingApprovalLink
              accessCustomer={accessCustomer}
              groupID={groupID}
              pendingApprovalsCount={pendingApprovalsCount}
            />{' '}
            |
            {disableAddSession ? (
              <span id={`disableSessionWarningIcon_${groupID}`} className="link-secondary px-2">
                <FontAwesomeIcon className="color-danger" icon="exclamation-triangle" />
                <UncontrolledTooltip placement="left" target={`disableSessionWarningIcon_${groupID}`}>
                  {cantAddSessionTooltipText}
                </UncontrolledTooltip>{' '}
                Can&apos;t Add Session
              </span>
            ) : (
              <button
                className="px-2 btn link-secondary"
                onClick={() => this.handleAddSession()}
                type="button"
              >
                + Add Session
              </button>
            )}
          </span>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  user
});


export default withRouter(
  connect(
    mapStateToProps,
    null
  )(AuctionGroupContainer)
);
